import { ResourcesConfig } from 'aws-amplify';
import { CookieStorage } from 'amazon-cognito-identity-js';
import parser from 'tld-extract';
import awsExports from '../aws-exports';
import debug from './debug';

const amplifyInit = () => {
  const tld =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '192.168.1.103'
      ? null
      : parser(window.location.href, { allowUnknownTLD: true });

  let domain = tld ? tld.domain : window.location.hostname;

  if (domain === 'saltusspace.co.uk') {
    domain = window.location.hostname;
  }

  debug('domain', domain);

  const config: ResourcesConfig = {
    ...(import.meta.env.VITE_APP_PINPOINT_APPID
      ? {
          Analytics: {
            Pinpoint: {
              appId: import.meta.env.VITE_APP_PINPOINT_APPID,
              region: 'us-east-1', // cognito pinpoint only supports this region
            },
          },
        }
      : {}),
    API: {
      GraphQL: {
        defaultAuthMode: 'userPool',
        endpoint: awsExports.aws_appsync_graphqlEndpoint,
        region: awsExports.aws_appsync_region,
      },
      REST: {
        forms: {
          endpoint: import.meta.env.VITE_APP_FORMS_API_ENDPOINT,
        },
      },
    },
    Auth: {
      Cognito: {
        allowGuestAccess: false,
        identityPoolId: awsExports.aws_cognito_identity_pool_id,
        userPoolId: awsExports.aws_user_pools_id,
        userPoolClientId: awsExports.aws_user_pools_web_client_id,
        loginWith: {
          email: true,
          ...(import.meta.env.VITE_APP_IDP &&
          import.meta.env.VITE_APP_AUTH_DOMAIN
            ? {
                oauth: {
                  domain: import.meta.env.VITE_APP_AUTH_DOMAIN,
                  scopes: [
                    'phone',
                    'email',
                    'profile',
                    'openid',
                    'aws.cognito.signin.user.admin',
                  ],
                  redirectSignIn: [`${window.location.origin}/`],
                  redirectSignOut: [`${window.location.origin}/`],
                  responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
                  providers: [
                    {
                      custom: import.meta.env.VITE_APP_IDP,
                    },
                  ],
                },
              }
            : {}),
        },
      },
    },
  };

  const cookieStorage = new CookieStorage({
    domain,
    path: '/',
    expires: 365,
    secure: import.meta.env.VITE_APP_SECURE_COOKIE === 'true',
  });

  return {
    config,
    cookieStorage,
  };
};

export default amplifyInit;
